import { Component } from "react";

import { inject, observer } from "mobx-react";

import styled from "styled-components/macro";
import { 
 } from "@blueprintjs/core";
import { 
  Pie
} from "react-chartjs-2";

import { withTranslation } from "react-i18next";
import i18n from "../../../../utils/i18n/i18n";

import { AppStore } from "../../../../stores/AppStore";


const Wrapper = styled.div``;
const ChartDiv = styled.div`
  width: 400px;
  border: 1px solid lightgray;
`;

interface CardsWIPByLabelProps {}

interface InjectedProps extends CardsWIPByLabelProps {
  appStore: AppStore;
}

@inject("appStore")
@observer
class CardsWIPByLabel extends Component<CardsWIPByLabelProps> {

  get injected() { return this.props as InjectedProps; }
  get userStore() { return this.injected.appStore.userStore; }
  get trelloStore() { return this.injected.appStore.trelloStore; }

  labels(label_ids: Array<string>) {
    return label_ids.map(label_id => {
      const label = this.trelloStore.selectableLabels.find(x => x.label_id === label_id);
      return label ? (label.name === '' ? 'none (gray)' : `${label.name} (${label.color})`) : '';
    })
  }

  colors(label_ids: Array<string>) {
    return label_ids.map(label_id => {
      const label = this.trelloStore.selectableLabels.find(x => x.label_id === label_id);
      return label ? (label.color === 'sky' ? 'skyblue' : label.color) : 'lightgray';
    })
  }

  render() {
    const data = JSON.parse(this.trelloStore.highlightsData);

    return (
      <Wrapper>
        <ChartDiv>
          <Pie 
            width={2}
            height={1}

            data={{
              labels: this.labels(data.wip_by_label.label_ids),
              datasets: [{
                label: '# of cards',
                data: data.wip_by_label.num_cards,
                backgroundColor: this.colors(data.wip_by_label.label_ids),
              }]            
            }}
            options={{
              title: {
                display: true,
                text: i18n.t("highlights-chart-bylabel")
              },
              legend: { 
                display: data.wip_by_label.label_ids.length <= 5,
                position: 'left', 
                // align: 'start' 
              },
            }}
          />
        </ChartDiv>
      </Wrapper>
    )
  }
}

export default withTranslation()(CardsWIPByLabel);